/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Bank_NetInputs */

const vi_cashflow_bank_net = /** @type {(inputs: Cashflow_Bank_NetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngân hàng ròng`)
};

/**

* @param {Cashflow_Bank_NetInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_bank_net = /** @type {((inputs?: Cashflow_Bank_NetInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Bank_NetInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_bank_net(inputs)
});